export const ComboType = {
  FLEXIBLE: 0,
  SPECIFIC: 1,
};
